<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import CompanyList from '@/router/views/planning/settings-template/company-list';
import CompanyType from '@/router/views/planning/settings-template/company-type';
import PriorityApi from '@/router/views/planning/settings-template/priority-api';
import ApiType from '@/router/views/planning/settings-template/api-type';
import IndicatorItemClassification from '@/router/views/planning/settings-template/indicator-item-classification';
import IndicatorItemGroups from '@/router/views/planning/settings-template/indicator-item-groups';
import PrexcClass from '@/router/views/planning/settings-template/prexc-classification';
import ExaminationList from '@/router/views/planning/settings-template/examination-list';
import AccreditorList from '@/router/views/planning/settings-template/accreditor-list';
import ResearchCategory from '@/router/views/planning/settings-template/research-category';
import ProgramCategory from '@/router/views/planning/settings-template/program-category';
import SurveyLevel from '@/router/views/planning/settings-template/survey-level';
import ResearchIndex from '@/router/views/planning/settings-template/research-index';
import KpiTags from '@/router/views/planning/settings-template/kpi-tags';
import ExtActFiles from '@/router/views/planning/settings-template/extension-activity-files';
import PapCat from '@/router/views/planning/settings-template/pap-category';
import ClusterList from "@/router/views/administration/settings-template/cluster-list";

export default {
    page: {
        title: "Planning Settings",
    },
    components: {
        Layout,
        PageHeader,
        CompanyList,
        CompanyType,
        PriorityApi,
        ApiType,
        IndicatorItemClassification,
        IndicatorItemGroups,    
        PrexcClass,
        ExaminationList,
        AccreditorList,
        ResearchCategory,
        ProgramCategory,
        SurveyLevel,
        ResearchIndex,
        KpiTags,
        ExtActFiles,
        PapCat,
        ClusterList
    },
    data() {
        return {
            title: "Planning Settings",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Planning Settings",
                    active: true,
                },
            ],
            papCategories: [],
            papCatLoading: false,
        }
    },
    async created(){
        this.papCatLoading = true;
        await this.getPapCategory();
        this.papCatLoading = false;
        await this.wait(500);
        this.getClusters();
    },
    methods: {
        getClusters(){
            this.$refs.clusterList.getClusters();
        },
        async getPapCategory(){
            await this.$store
                .dispatch("papcategory/GetPapCategory")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map(item => {
                        item.body = item.category;
                    })
                    this.papCategories = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        }
    },
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-tabs
            pills
            vertical
            nav-class="p-0"
            nav-wrapper-class="col-sm-2"
            content-class="pt-0 px-2 text-muted"
        >
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                <span class="d-inline-block d-sm-none">
                    <i class="bx bx-home"></i>
                </span>
                <span class="d-none d-sm-inline-block">Cluster</span>
                </template>
                <cluster-list ref="clusterList"></cluster-list>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Company</span>
                </template>
                <company-list ref="companyList"></company-list>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Company Type</span>
                </template>
                <company-type ref="companyType"></company-type>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >PAP Category</span>
                </template>
                <pap-cat 
                    ref="papCat"
                    :loading="papCatLoading"
                    :tableData="papCategories"
                ></pap-cat>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >API Type</span>
                </template>
                <api-type 
                    :papCategories="papCategories"
                    ref="apiType"
                ></api-type>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Priority API</span>
                </template>
                <priority-api ref="priorityApi"></priority-api>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >KPI Classification</span>
                </template>
                <indicator-item-classification ref="indicatorItemClassification"></indicator-item-classification>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >KPI Groups</span>
                </template>
                <indicator-item-groups ref="indicatorItemGroups"></indicator-item-groups>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Program Cluster</span>
                </template>
                <prexc-class ref="prexcClass"></prexc-class>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Examinations</span>
                </template>
                <examination-list></examination-list>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Accreditors</span>
                </template>
                <accreditor-list></accreditor-list>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Research Categories</span>
                </template>
                <research-category></research-category>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Research Indeces</span>
                </template>
                <research-index></research-index>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Program Categories</span>
                </template>
                <program-category></program-category>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >Accreditation Status</span>
                </template>
                <survey-level></survey-level>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block"
                        >KPI Tags</span>
                </template>
                <kpi-tags></kpi-tags>
            </b-tab>
            <b-tab title-item-class="mb-2">
                <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="bx bx-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">Extension Activity Files</span>
                </template>
                <ExtActFiles />
            </b-tab>
        </b-tabs>
    </Layout>
</template>